<template>
    <div>
        <div class="row">
            <div class="col-md-12 card-wrapper">
                <div class="card">
                    <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('RESTORE')}}</div>
                    <div class="card-body bg-light">
                        <div class="row">
                            <div class="col-md-6">
                                <div v-html="$ml.get('RESTORE_WARN')"></div>
                            </div>
                            <div class="col-md-6">
                                <div class="card" style="width: 100%">
                                    <div class="card-header crm-modal-header d-flex justify-content-between align-items-center">
                                        <span>{{$ml.get('VERSION_DATE')}}</span>
                                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#restoreAttentionModal">{{$ml.get('RESTORE')}}</button>
                                    </div>
                                    <div class="restore-list-wrapper">
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item list-group-item-action d-flex align-items-center" v-for="(day,index) in lastWeek" v-bind:key="index" @click="selectedDate=$moment(day).format('YYYY-MM-DD')">
                                                <input type="radio" v-model="selectedDate" :value="$moment(day).format('YYYY-MM-DD')"/> 
                                                <span class="pl-2">{{day}} {{$ml.get('VERSION_DATE_LABEL')}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal show" tabindex="-1" role="dialog" data-backdrop="static" id="restoreAttentionModal" aria-labelledby="restoreAttentionModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-danger">{{$ml.get('ATTENTION')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-html="$ml.get('RESTORE_ATTENTION_TEXT')"></div>
                    </div>
                    <div class="modal-footer dealBtnStyle">
                        <button type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn-new save" data-dismiss="modal" data-toggle="modal" data-target="#restoreConfirmModal">{{$ml.get('PROCEED_RESTORE')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal show" tabindex="-1" role="dialog" data-backdrop="static" id="restoreConfirmModal" aria-labelledby="restoreConfirmModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-danger">{{$ml.get('RESTORE_CONFIRM_TITLE')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-html="$ml.get('RESTORE_CONFIRM_TEXT')"></div>
                        <div class="form-group">
                            <label for="confirmInput" v-html="$ml.get('RESTORE_CONFIRM_INPUT_LABEL')"></label>
                            <input type="text" class="form-control" id="confirmInput" aria-describedby="confirmInputHelp" v-model="confirmText" @input="showConfirmationError=false">
                            <small v-if="showConfirmationError" id="confirmInputHelp" class="form-text text-danger" v-html="$ml.get('RESTORE_CONFIRM_INPUT_HELP')"></small>
                        </div>
                    </div>
                    <div class="modal-footer dealBtnStyle">
                        <button type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn-new save" @click="instructBackupRestorationF()">{{$ml.get('RESTORE')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name:'systemRestore',
    data() {
        return {
            selectedDate:'',
            showConfirmationError:false,
            confirmText:''
        }
    },
    computed:{
        lastWeek(){
            var lastWeek = []
            var today = this.$moment()
            for(var i = 0 ; i<7;i++){
                var day = this.$moment().add(-i,'days').format("YYYY-MM-DD 00:00") 
                lastWeek.push(day)
            }
            this.selectedDate = this.$moment(lastWeek[0]).format('YYYY-MM-DD')
            return lastWeek
        }
    },
    methods:{
        ...mapActions(['instructBackupRestoration']),
        instructBackupRestorationF(){
            if(this.confirmText!=='Minimum CRM'){
                this.showConfirmationError=true
                return false
            }else{
                this.showConfirmationError=false
                var form ={}
                form.backupDay = this.selectedDate
                this.instructBackupRestoration(form).then((res)=>{return res}).then((res)=>{
                    if(res.data.status.code==0){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.data.status.desc 
                        })
                        this.$router.push('/recoveryInprogress')
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.desc 
                        })
                    }
                    $('#restoreConfirmModal').modal('hide')
                    this.confirmText=''
                })
            }
        }
    }
}
</script>
<style scoped>
    .list-group > li:nth-child(odd){
        background-color:#F4F4F4;
    }
    .list-group > li:hover{
        background-color:#f8f9fa!important;
    }
    button.save{
        width: auto!important;
    }
</style>